<template>
    <div class="change-password container">
        <div class="goback container">
            <button @click="goBackAccount">
                <svg xmlns="http://www.w3.org/2000/svg" width="67" height="25" viewBox="0 0 67 25">
                    <text id="_voltar" data-name="&lt; voltar" transform="translate(0 19)" fill="#aeaeae" font-size="18" font-family="Poppins-Regular, Poppins"><tspan x="0" y="0">&lt; {{ $t('back') }}</tspan></text>
                </svg>
            </button>
        </div>
        <div class="change-password-content">
            <h1 class="v-content-change-password" v-contentChangePassword="{ section: 'Account', removeHtml: true }">Alterar palavra-passe</h1>
            <form @submit.prevent="changePassword()">
                <div class="form-group form-box">
                    <label for="password" class="password v-content-change-password" v-contentChangePassword="{ section: 'Account', removeHtml: true }">Palavra-passe</label>
                    <input type="password" id="password" name="password" v-model="password" placeholder="" required>
                </div>
                <div class="form-group form-box">
                    <label for="password" class="rep-password v-content-change-password" v-contentChangePassword="{ section: 'Account', removeHtml: true }">Repetir palavra-passe</label>
                    <input type="password" id="rep-password" name="rep-password" v-model="rep_password" placeholder="" required>
                </div>
                <button type="submit" class="v-content-change-password" v-contentChangePassword="{ section: 'Account', removeHtml: true }">Submeter</button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import store from "@/store";
import { mapState, mapActions } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
    data() {
        return {
            password: '',
            rep_password: '',
        }
    },
    computed: {
        ...mapState('App', ['loading']),
    },
    methods: {
        ...mapActions('App', ['toggleAccount']),  // Aqui estamos mapeando a ação 'toggleAccount'
    
        goBackAccount() {
            this.toggleAccount();  // Agora 'toggleAccount' é uma ação do Vuex e é chamada corretamente
        },
        async changePassword() {
            if (this.password !== this.rep_password) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'As senhas não são iguais!',
                    timer: 5000,
                });
                return;
            }
            store.dispatch('App/loading', true);
            try {
                const response = await axios.post('/api/v1/user/change-password', {
                    password: this.password,
                    token: localStorage.getItem('token'),
                    lang: lang
                },
                { withCredentials: true }
                );
                
                store.dispatch('App/loading', false);

                if (response.data.success) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: response.data.message,
                        timer: 5000,
                    });
                    this.$router.push('/cuenta');
                    this.$router.go();
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: response.data.error.error.message,
                        timer: 5000,
                    });
                }
            } catch (error) {
                console.error(error);
                store.dispatch('App/loading', false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao alterar a palavra-passe!',
                    timer: 5000,
                });
            }
        },
        updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-change-password');
            allContents.splice(0, allContents.length);
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
        contentChangePassword: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-change-password');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-change-password');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    },
}
</script>


<style lang="scss" scoped>
.change-password {
    margin-top: -40px;
    &-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: 35px;
        @media screen and (max-width: 768px) {
            height: auto;
            gap: 50px;
        }

        h1 {
            font-size: 35px;
            font-family: 'Font Bold';
            color: #E84E0F;
            text-align: left;
        }

        h3 {
            font-size: 25px;
            color: #000;
            font-family: 'Font Regular';
            text-align: left;
        }

        form {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            width: 100%;
            @media screen and (max-width: 768px) {
                align-items: center;
            }

            .form-group {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                @media screen and (max-width: 768px) {
                    flex-direction: row;
                    align-items: flex-start;
                    width: 100%;
                }
                .password{
                    margin-right: 150px;
                }
                .rep-password{
                    margin-right: 95px;
                }

                label {
                    font-size: 16px;
                    font-family: 'Font Medium';
                    margin-bottom: 5px;
                    text-align: left;
                    max-width: 80%;
                    width: 80%;
                    @media screen and (max-width: 768px) {
                        margin-right: 0;
                    }
                }

                input[type="text"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }

                input[type="password"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }

                input[type="checkbox"] {
                    appearance: none;
                    width: 40px;
                    height: 40px;
                    border: 1px solid #787878;
                    border-radius: 7px;
                    position: relative;
                    margin-right: 20px;
                    cursor: pointer;
                    &:checked {
                        background-color: none;
                        &::after {
                            content: '✔';
                            color: #85D160;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 40px;
                        }
                    }
                }
                
                .form-group--checkbox {
                    display: flex;
                    align-items: flex-start;
                    .checkbox-container {
                        display: flex;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                    }
                }
            }

            .form-box{
                @media screen and (max-width: 768px) {
                    flex-direction: column;
                    gap: 20px;
                }
            }
            button {
                height: 71px;
                width: 328px;
                max-width: 100%;
                background-color: var(--main-color);
                color: #fff;
                font-size: 25px;
                font-family: 'Font Regular';
                border: none;
                border-radius: 7px;
                cursor: pointer;

                &:hover {
                    background-color: #AEAEAE;
                }
            }
        }
    }
}
</style>
